import Vue from "vue";
import getBaseUrl from "../config/baseUrl";

Vue.prototype.$offices = new Vue({
  methods: {
    get() {
      return new Promise((resolve, reject) => {
        this.$http
          .get(`${getBaseUrl()}offices`)
          .then((result) => resolve(result.data))
          .catch((error) => reject(error));
      });
    },
  },
});
